<template>
  <div class="ae2-widget-menu" v-bind:class="menuClass" v-if="isAngulareReady">
    <div class="ae2-widget-menu-group" v-if="!isLogged">
      <div class="ae2-widget-menu-message">
        <p class="ae2-widget-menu-title text">Bem-vindo!</p>
        <p class="ae2-widget-menu-subtitle text">Não possui uma conta?</p>
      </div>
      <div v-if="loginMode=='v1'">
        <button class="ae2-widget-menu-btn ae2-widget-menu-btn__primary" v-on:click="showLoginModal">
          <span class="text">{{ buttonsConfig.loginBtnText }}</span>
        </button>
        <button class="ae2-widget-menu-btn ae2-widget-menu-btn__secondary" v-on:click="showSignupModal">
          <span class="text">{{ buttonsConfig.signupBtnText }}</span>
        </button>
      </div>
      <div v-if="loginMode=='v2'">
        <button class="ae2-widget-menu-btn ae2-widget-menu-btn__primary" v-on:click="showLoginSignupModal">
          <span class="text">{{ buttonsConfig.loginBtnText }}</span>
        </button>
      </div>
    </div>

    <div class="ae2-widget-menu-group" v-if="isLogged">
      <div class="ae2-widget-menu-message">
        <p class="ae2-widget-menu-title">
          Olá! <span class="ae2-widget-menu-username">{{ username }}</span>
        </p>
      </div>
      <button class="ae2-widget-menu-btn ae2-widget-menu-btn__primary" v-on:click="navigateMyAccount">
        <span class="text">{{ buttonsConfig.accountBtnText }}</span>
      </button>
      <button class="ae2-widget-menu-btn ae2-widget-menu-btn__secondary" v-on:click="logout">
        <span class="text">{{ buttonsConfig.signoutBtnText }}</span>
      </button>
    </div>

    <div class="ae2-widget-menu-group">
      <button class="ae2-widget-menu-btn ae2-widget-menu-btn__checkout"  v-on:click="showCheckoutModal">
        <span class="text">
          <i v-bind:class="iconCode" class="ae2-wdiget-menu-btn-icon"></i>
          <span class="ae2-widget-menu-btn-description">Carrinho de Compras</span>
        </span>
      </button>
    </div>
  </div>
</template>

<style scoped>
.ae2-widget-menu {
  display: flex;
  align-items: flex-start;
}

.ae2-widget-menu.ae2-widget-menu__mobile {
  display: flex;
  flex-direction: column;
}

.ae2-widget-menu-message {
  padding: 8px 24px 8px 0;
  display: none;
}

.ae2-widget-menu.ae2-widget-menu__mobile .ae2-widget-menu-message {
  display: block;
}

.ae2-widget-menu-title {
  font-size: 2.5rem;
  margin-bottom: 0px;
}

.ae2-widget-menu-subtitle {
  font-size: 1rem;
  margin-bottom: 0;
}

.ae2-widget-menu-username {
  font-weight: bold;
}

.ae2-widget-menu .ae2-widget-menu-group {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.ae2-widget-menu.ae2-widget-menu__mobile .ae2-widget-menu-group {
  margin-bottom: 16px;
}

.ae2-widget-menu .ae2-widget-menu-group__hidden {
  display: none;
}

.ae2-widget-menu-btn {
  border:none;
  font-size:1em;
  padding: 8px 8px;
  margin: 0 4px;
  border-width: 1px;
  border-style: solid;
}

.ae2-widget-menu.ae2-widget-menu__mobile .ae2-widget-menu-btn .ae2-widget-menu-btn-icon {
  margin-right: 4px;
}

.ae2-widget-menu .ae2-widget-menu-btn .ae2-widget-menu-btn-description {
  display: none;
}

.ae2-widget-menu.ae2-widget-menu__mobile .ae2-widget-menu-btn .ae2-widget-menu-btn-description {
  display: inline-block;
}
</style>

<script>
import { isDone } from '../../util'
import modals from "../../components/modals";
import auth from '../../authentication';

export default {
  props: {
    loginMode:{
      type:String,
      default:()=>('v1')
    },
    device: String,
    iconCode: String,
    myAccountPage: Object,
    buttonsConfig: Object,
  },

  created: function() {
    isDone().then(() => {
      this.isAngulareReady = true

      window.AngularEcommerce.web.stores.watch(() => this.onAuthStatusChange())
    })
  },

  data() {
    return {
      isAngulareReady: false,
      isLogged: false,
      username: '',
    }
  },

  methods: {
    showLoginModal: modals.showLoginModal,
    showSignupModal: modals.showSignupModal,
    showCheckoutModal: modals.showCheckoutModal,
    showLoginSignupModal: modals.showLoginSignupModal,

    navigateMyAccount: function() {
      if (location.hostname === 'localhost') {
        location.href = '/?widget=ae-my-account'
      }

      if (this.myAccountPage) {
        location.href = this.myAccountPage.value + location.search
      }
    },

    logout(event) {
      auth.onLogout(event)
    },

    onAuthStatusChange: function () {
      this.isLogged = window.AngularEcommerce.web.stores.getters['auth/isLogged']

      if (!this.isLogged) {
        return
      }

      const user = window.AngularEcommerce.web.stores.getters['auth/user']
      this.username = user.first_name
    }

  },

  computed: {
    menuClass() {
      const isMobile = this.device === 'tablet' || this.device === 'mobile'

      return {
        'ae2-widget-menu__mobile': isMobile,
        'ae2-widget-menu--logged': this.isLogged,
        'ae2-widget-menu--unlogged': !this.isLogged,
      }
    }
  }

};
</script>